import { Container, Typography, Box, Link as MuiLink } from "@mui/material";
import { Link } from "react-router-dom";
import SectionTitle from "../ui/SectionTitle";

export default function PrivacyPolicyPage() {
    return (
        <Box sx={{ bgcolor: "background.default", minHeight: "100%", py: 4 }}>
            <Container maxWidth="md" sx={{ py: 2 }}>
                <SectionTitle>Политика конфиденциальности</SectionTitle>

                <Typography variant="body2" color="text.secondary" sx={{ mt: 3, mb: 3, textAlign: "center" }}>
                    Дата вступления в силу: 6 декабря 2025 г.
                </Typography>

                <Box sx={{ "& p": { mb: 2 } }}>
                    <Typography component="p">
                        Настоящая Политика разработана в соответствии с Федеральным законом от 27.07.2006 №152-ФЗ «О персональных данных».
                    </Typography>

                    <Typography component="p">
                        <strong>1. Сбор персональных данных.</strong> Администрация сайта не осуществляет сбор, хранение, передачу или иную обработку персональных данных пользователей.
                    </Typography>

                    <Typography component="p">
                        <strong>2. Технологии отслеживания.</strong> На сайте не используются cookies, веб-маяки, пиксельные метки или иные средства автоматического сбора информации.
                    </Typography>

                    <Typography component="p">
                        <strong>3. Основания обработки.</strong> В соответствии с ч. 5 ст. 6 и ч. 3 ст. 18 ФЗ‑152, при отсутствии обработки персональных данных получение согласия не требуется.
                    </Typography>

                    <Typography component="p">
                        <strong>4. Обратная связь.</strong> В случае появления функционала, связанного с обработкой ПДн, настоящая Политика будет обновлена, а согласие — получено отдельно.
                    </Typography>

                    <Typography component="p">
                        <strong>5. Контакты.</strong> Вопросы направляйте на: <strong>shamovneva74@bk.ru</strong>.
                    </Typography>
                </Box>

                <Box sx={{ mt: 4, textAlign: "center" }}>
                    <MuiLink component={Link} to="/" color="secondary" underline="hover" fontWeight={600}>
                        Вернуться на главную
                    </MuiLink>
                </Box>
            </Container>
        </Box>
    );
}
